export const IMAGE_URL = "https://node.nucleargauges.com:5000/images"